import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { getParams } from '@hglobal/fin-ui';
import { concatMap, from, map, Observable, toArray } from 'rxjs';

import { environment } from '@kr/environment';
import { GetTotalBalanceReq, Provider, ProviderTotalBalance } from '@kr/models';
import { OrganizationService } from '@kr/services';

import { ShellApi } from './shell-api.interface';
import { GetAccountRes } from '../../pages/account/models';
import { SupportLink } from '../models/support-link.model';

@Injectable()
export class ShellApiService implements ShellApi {
  readonly #http = inject(HttpClient);
  readonly #apiHost = environment.apiHost;
  readonly #organizationService = inject(OrganizationService);

  getAccount(): Observable<GetAccountRes> {
    const api = `${this.#apiHost}/me/user`;

    return this.#http.get<GetAccountRes>(api);
  }

  getSupportLink(): Observable<SupportLink> {
    const api = `${this.#apiHost}/support/urls/telegram/generate/`;

    return this.#http.post<SupportLink>(api, null, {
      headers: this.#organizationService.getHttpHeaders(),
    });
  }

  getTotalBalances(providers: Provider[]): Observable<ProviderTotalBalance[]> {
    const payload = { currency_id: 1 }; // default currency
    return from(providers).pipe(
      concatMap(provider => this.getTotalBalance(payload, provider)),
      toArray(),
    );
  }

  getTotalBalance(params: GetTotalBalanceReq, provider: Provider): Observable<ProviderTotalBalance> {
    return this.#http
      .get<ProviderTotalBalance>(`${this.#apiHost}/wallets/total_balance/`, {
        params: getParams(params),
        headers: this.#organizationService.getHttpHeaders(provider.id),
      })
      .pipe(map(res => ({ ...res, provider })));
  }
}
